import { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as actions from './actions'

export const useUser = () => {

    const {
        userData,
        initialize,
        profiles,
        socialMedia,
        explorePeople,
        refreshPeople
    } = useSelector((state) => state.user);

    const dispatch = useDispatch();

    const setSocialMedia = useCallback(
        (payload) => dispatch(actions.setSocialMedia(payload)),
        [dispatch]
    );

    const setExplorePeople = useCallback(
        (payload) => dispatch(actions.setExplorePeople(payload)),
        [dispatch]
    )

    return {
        userData,
        initialize,
        profiles,
        socialMedia,
        setSocialMedia,
        explorePeople,
        refreshPeople,
        setExplorePeople
    };
} 